<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowDown_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13.433 8.327a.65.65 0 0 0-.817-.203L9 9.921V3a1 1 0 0 0-2 0v6.921L3.384 8.124a.65.65 0 0 0-.748 1.042l4.905 4.905a.65.65 0 0 0 .919 0l4.905-4.905a.65.65 0 0 0 .068-.839"
    />
</svg>
